import domain from './domain';

// Set current path location
export const setCurrentPathLocation = domain.createEvent<string>('setCurrentPathLocation');

// Reset current path location
export const resetCurrentPathLocation = domain.createEvent('resetCurrentPathLocation');
